import React from "react";
import { useCurrency, setCurrency } from "@/lib/currency";

// Discreet US$ | AWG display-currency switch (navbar + mobile menu).
export const CurrencyToggle = ({ testId = "currency-toggle", className = "" }) => {
  const cur = useCurrency();
  const opt = (value, label) => (
    <button
      type="button"
      onClick={() => setCurrency(value)}
      aria-pressed={cur === value}
      data-testid={`${testId}-${value}`}
      className={`px-2 py-0.5 rounded-full transition-colors ${
        cur === value ? "bg-[#FF6600] text-black" : "text-[#A3A3A3] hover:text-white"
      }`}
    >
      {label}
    </button>
  );
  return (
    <div
      data-testid={testId}
      role="group"
      aria-label="Display currency"
      className={`inline-flex items-center gap-0.5 rounded-full border border-[#262626] p-0.5 text-[10.5px] font-bold tracking-[0.08em] ${className}`}
    >
      {opt("usd", "US$")}
      {opt("awg", "AWG")}
    </div>
  );
};
